import { PrivyProvider } from "@privy-io/react-auth";
import type { ReactNode } from "react";

const appId = import.meta.env.VITE_PRIVY_APP_ID;

if (!appId) {
  console.warn("VITE_PRIVY_APP_ID is not set — Privy auth will not work.");
}

interface AppPrivyProviderProps {
  children: ReactNode;
}

export function AppPrivyProvider({ children }: AppPrivyProviderProps) {
  return (
    <PrivyProvider
      appId={appId ?? "missing-privy-app-id"}
      config={{
        loginMethods: ["email"],
        appearance: {
          theme: "light",
          accentColor: "#0f766e",
          showWalletLoginFirst: false,
          walletList: [],
        },
        embeddedWallets: {
          createOnLogin: "off",
          requireUserPasswordOnCreate: false,
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
}
